import axiosInstance from "../../axios/instance";
import { normalizeToUTC } from "@revbox/helpers-fe";
import { endOfDay, startOfDay } from "date-fns";
import { getToken } from "../../helpers/get-token";

async function getPeriodCampaignImpressionsAndClicks(currentPeriod, campaignId, current_token) {
    try {
        console.log("currentPeriod", currentPeriod);
        const token = current_token || getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;
        const response = await axiosInstance.post(process.env.REACT_APP_HUB_URL + '/api/analytics/campaign/period/impressions-and-clicks', {
            current_period: [
                startOfDay(normalizeToUTC(currentPeriod[0])).getTime(),
                endOfDay(normalizeToUTC(currentPeriod[1])).getTime()
            ],
            campaign_id: campaignId
        })
        return response?.data?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getPeriodCampaignImpressionsAndClicks;
